module.exports = __webpack_public_path__ + "static/product2_5-5e523f20a8795f1b08f5f2f1975ef426.jpg";